import styled from "styled-components";

export const SelectDropdownWrapper = styled.div`
    position: relative;
    width: 100%;

    input:first-child {
        cursor: default;
        caret-color: transparent;
        text-transform: capitalize;
        padding-right: 26px;

        &:disabled {
            cursor: not-allowed;
        }
    }

    svg {
        width: 16px;
        height: 16px;
        color: var(--text-color-secondary);
        position: absolute;
        top: 0;
        bottom: 0;
        right: 12px;
        margin: auto;
        transform: rotate(90deg);
        transition: all ease-in-out 0.3s;

        &.chevron-rotate {
            transform: rotate(-90deg);
        }
    }
`;

export const DropdownOptions = styled.div`
    position: absolute;
    top: 120%;
    right: 0;
    z-index: 8;
    min-width: 100%;
    /* max-width: 250px; */
    max-width: 100%;
    max-height: 40vh;
    background-color: var(--theme-color-secondary);
    border: 1px solid var(--border-color);
    padding: ${({ $showSearch }) => $showSearch ? '0 0 5px 0' : '5px 0'};
    border-radius: 10px;
    overflow: auto;

    ul {
        list-style-type: none;
        padding: 0;
        margin: 0;
        font-size: 14px;

        > *:not(:last-child) {
            border-bottom: 1px solid var(--table-border-color);
        }

        li {
            background-color: transparent;
            color: var(--text-color-secondary);
            text-transform: capitalize;
            padding: 10px 20px;
            cursor: pointer;
            transition: all ease-in-out 0.3s;

            span {
                color: inherit;
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                text-overflow: ellipsis;
            }

            &:hover {
                background-color: var(--table-border-color);
            }

            &.active {
                background-color: var(--theme-color-primary);
                color: var(--theme-color-white);
            }
        }
    }
`;

export const SearchWrapper = styled.div`
    position: sticky;
    top: 0;
    background-color: var(--theme-color-secondary);
    border-bottom: 1px solid var(--table-border-color);
    padding: 5px;
`;

export const SearchContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 0;
    border: 1px solid var(--border-color);
    border-radius: 50px;
    padding: 2px 16px;

    svg {
        flex-shrink: 0;
        appearance: none;
        color: var(--text-color-secondary);
        position: unset;
        width: 16px;
        height: auto;
        margin: 0;
        transform: unset;
    }

    input {
        flex: 1;
        width: 100%;
        appearance: none;
        background-color: transparent;
        color: var(--text-color-secondary);
        padding: 4px;
        border: none;
        font-size: 13px;

        &:focus {
            outline: none;
        }

        &::placeholder {
            color: var(--text-color-secondary);
            opacity: 0.6;
            font-size: 13px;
        }
    }
`;